import React, { useState } from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AdvisorCallbackForm } from '@/components/AdvisorCallbackForm/AdvisorCallbackForm';
import { Loader } from '@/components/Loader/loader';
import { ROUTE } from '@/constants/route';
import { useSendRappelConseiller } from '@/hooks/useSendRappelConseiller';
import { Day } from '@/services/types/Rappel';
import { log } from '@/utils/functions/logger/logger';

import styles from './styles.module.css';

type ModalRappelProps = {
  onClose: () => void;
  data: Day[];
};

export const ModalRappel: React.FC<ModalRappelProps> = ({ onClose, data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sendCallback = useSendRappelConseiller();

  let user = null;
  if (sessionStorage.user) {
    user = JSON.parse(sessionStorage.user);
  }

  const [validateRappel, setValidateRappel] = useState(false);
  const [validateRappelLoading, setValidateRappelLoading] = useState(false);

  const handleFormSubmit = (formData: FormData) => {
    setValidateRappelLoading(true);

    formData.append('nomRappel', user?.nom ?? '');
    formData.append('prenomRappel', user?.prenom ?? '');
    formData.append('typeContactRappel', user?.type ?? '');
    formData.append('idSFRappel', user?.id ?? '');
    formData.append('emailRappel', user?.email ?? '');
    formData.append('cpRappel', user?.codePostal ?? '');
    formData.append('g-recaptcha-response', '');

    sendCallback.mutate(formData, {
      onSuccess: (cData) => {
        setValidateRappel(cData.valide);
        setValidateRappelLoading(false);
        document.body.classList.remove('modal-open');
        onClose();
      },
      onError: (error) => {
        setValidateRappelLoading(false);
        navigate(ROUTE.ERREUR, { state: { goTo: ROUTE.DASHBOARD } });
        log.error(`ModalRappel: Error sending rappel: ${error}`);
      },
    });
  };

  return (
    <>
      {validateRappelLoading && <Loader />}

      {validateRappel ? (
        <div className={styles.validationMessage}>
          <i className="totem-icon totem-icon-check-circle-solid" />
          <p className={styles.requestTitle}>{t('helpContact.requestConfirmation')}</p>
          <p className={styles.advisorMessage}>{t('helpContact.advisorCallback')}</p>
          <MtxButton
            className={styles.btn}
            onClick={() => {
              document.body.classList.remove('modal-open');
              onClose();
            }}
            variant="primary"
            size="medium"
          >
            <div>{t('helpContact.backToHome')}</div>
          </MtxButton>
        </div>
      ) : (
        <>
          <h3 className={styles.subtitle}>
            {t('helpContact.wording')} <br /> {t('helpContact.callbackSuggestion')}
          </h3>
          <AdvisorCallbackForm
            data={data}
            onSubmit={handleFormSubmit}
            isLoading={validateRappelLoading}
            scrollAnchorId="modal-rappel-anchor"
          />
        </>
      )}
    </>
  );
};
